
export default { name: 'App' }
